import { Input } from "@xola/ui-kit";
import { FormFieldContext, useError } from "common";
import { useField } from "formik";
import { isString } from "lodash";
import React, { InputHTMLAttributes, useContext } from "react";

// Let's leave these here for a while, just in case.
// I'm still trying to figure out the best way to type regular HTML elements.
// type InputProps = Partial<HTMLInputElement>;
// type InputProps = DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>;

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
    as?: (props: any) => JSX.Element;
    isRequired?: boolean;
}

export const InputField = ({ as: Tag = Input, isRequired, ...rest }: InputProps) => {
    const name = useContext(FormFieldContext);
    const [field, , helpers] = useField(name);
    const error = useError(name);

    const handleBlur = (e: any) => {
        helpers.setValue(isString(field.value) ? field.value.trim() : field.value);
        field.onBlur(e);
    };

    return (
        <Tag
            isRequired={isRequired}
            isError={!!error}
            {...rest}
            {...field}
            value={field.value || ""}
            onBlur={handleBlur}
        />
    );
};
